import SouthEastIcon from '@mui/icons-material/SouthEast';

export const brandingTypes = [
    {id: Math.random(), type: "naming", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "branding", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "logoDesign", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "packagingDesign", arrow: <SouthEastIcon/>},
]